export default __webpack_public_path__ + "static/media/hangman.ea2c5a43.png";